<template>
  <div>
    <ManageJobs :customers="customers"></ManageJobs>
    <ManageCustomers :tableData="customers" class="mt-2"></ManageCustomers>
  </div>
</template>

<script>
import { db } from '../assets/js/firebase/db.js';

import ManageJobs from '../components/childComponents/manageJobs.vue';
import ManageCustomers from '../components/childComponents/manageCustomers.vue';

export default {
  name: 'manageJobsAndCustomers',
  components: { ManageJobs, ManageCustomers },
  data() {
    return {
      customers: [],
      jobs: []
    };
  },
  methods: {
    getCustomers: function() {
      db.collection('customers')
        .where('org', '==', this.$store.state.userCompany)
        .where('deleted', '==', false)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            let index = this.customers.push(doc.data());
            this.customers[index - 1]['id'] = doc.id;
          });
        })
        .catch(err => {
          console.log(`Error getting customers: ${err}`);
          this.showError('Error getting customers');
        });
    }
  },
  mounted() {
    this.getCustomers();
  }
};
</script>

<style scoped></style>
